import React from "react";
import { flatten } from "lodash";
import { ServiceType, CompanyType } from "@/types";
import { isBefore } from "@/misc/datetime";
import { getCountry } from "countries-and-timezones";

const ServiceStructuredData: React.FC<{
  service: ServiceType;
  company: CompanyType;
}> = ({ service, company }) => {
  {
    const serviceUrl = `https://embed.bookmore.com?articleIdsToShow=&bookLayout=service-based&bookMethods=contact-information%2Clogin%2Clogin-facebook&company=${company.Id}&darkTheme=false&hideServiceImage=false&hideServiceInfo=false&language=sv&listingLayout=rows&preventAutoscroll=false&selectedService=${service.Id}&serviceIdsToShow=&showEndTimeOnTimeslots=false&showNextAvailableTime=false&timesLayout=week&topOffset=0&translations=%5B%5D`;

    return (
      <script type="application/ld+json" key={service.Id}>
        {JSON.stringify({
          "@context": "https://schema.org/",
          "@type": "Service",
          provider: {
            "@type": "LocalBusiness",
            ...(company && company.Name ? { name: company.Name } : {}),
            ...(company && company.ZipCode && company.CountryId && company.City && company.Street1 ? {
              "address": {
                "@type": "PostalAddress",
                "addressLocality": `${company.City}, ${getCountry(company.CountryId.toUpperCase())?.name}`,
                "postalCode": company.ZipCode,
                "streetAddress": company.Street1,
              },
              ...(company && company.Longitude && company.Latitude ? {
                "geo": {
                  "@type": "GeoCoordinates", longitude: company.Longitude, latitude: company.Latitude
                }
              } : {}),
            } : {}),
          },
          image: service.ImageUrl,
          name: service.Name,
          description: service.Description,
          ...(service.Prices.length > 0 ? {
            offers: service.Prices.map((price) => ({
              "@type": "Offer",
              price: price.Price,
              priceCurrency: price.CurrencyId,
              // url: serviceUrl,
              ...(service.Active ? { "availability": "https://schema.org/InStock" } : {}),
            }))
          }
            : {
              offer: {
                "@type": "Offer",
                // url: serviceUrl,
                ...(service.Active ? { "availability": "https://schema.org/InStock" } : {}),
              }
            }),
        })}
      </script>
    );
  }
};

export default ServiceStructuredData;
